import { useSelector } from 'react-redux'
import { useAppRole } from '@/hooks/useAppRole'
import { RootState } from '@/redux/store'
import { AnimationSkeleton } from '@/pages/ui/Skeleton'
import CustomerPortalDashboard from './CustomerPortalDashboard'
import SuperAdminDashboard from './SuperAdminDashboard'
import BasicUserDashboard from './BasicUserDashboard'

const Dashboard = () => {
	const { isSuperAdmin, isTenantAdmin } = useAppRole()
	const permissionsLoaded = useSelector((state: RootState) => state.Auth.permissionsLoaded)

	// Wait for real permissions before deciding which dashboard to show - otherwise every
	// role briefly flashes the Basic-user fallback while permissions are still loading.
	if (!permissionsLoaded) {
		return (
			<div className="min-w-0 w-full py-4 text-foreground">
				<AnimationSkeleton />
			</div>
		)
	}

	if (isTenantAdmin && !isSuperAdmin) {
		return <CustomerPortalDashboard />
	}

	if (isSuperAdmin) {
		return <SuperAdminDashboard />
	}

	// Plain "User" role (Basic permission set) - no admin permissions, so land on a simple
	// welcome page scoped to whatever they're actually permitted to see.
	return <BasicUserDashboard />
}

export default Dashboard
